import { useMemo } from 'react';

import { Button } from 'components/Button';

import { GatsbyLink } from 'components/Links';
import { FlexContainer } from 'components/FlexContainer';
import { PreferenceItem } from './PreferenceItem';
import { BannerContainer, Header, Text, CookieInfoContainer } from '../styled/Container.styled';
import { cookieInfoMap } from '../constants';

import type { FC } from 'react';
import type { CookiePreferencesProps } from '../types';

export const CookiePreferences: FC<CookiePreferencesProps> = ({
  preferences,
  onRejectAll,
  onAccept,
  onPreferenceClick,
}) => {
  const renderedPreferenceItems = useMemo(
    () =>
      cookieInfoMap.map(({ title, description, cookieType }, key) => (
        <PreferenceItem
          key={cookieType}
          checked={preferences[cookieType]}
          title={title}
          description={description}
          disabled={key === 0}
          onclick={() => onPreferenceClick(cookieType, !preferences[cookieType])}
        />
      )),
    [onPreferenceClick, preferences]
  );

  return (
    <BannerContainer>
      <CookieInfoContainer>
        <Header>Cookie preferences</Header>
        <Text>
          Pick which cookie categories you consent to by using the sliders below. You can update
          your preferences at any time by clicking on 'Manage cookies' in the footer. Find more
          information about what cookies we use in our{' '}
          <GatsbyLink textColor="white" to="cookie-policy">
            Cookie Policy
          </GatsbyLink>
          .
        </Text>
        {renderedPreferenceItems}
      </CookieInfoContainer>
      <FlexContainer justifyContent="space-between" flexWrap="wrap" gap={4}>
        <Button
          onClick={onRejectAll}
          appearance="secondary"
          containerBackground="negative"
          title="Reject All"
        >
          Reject optional cookies
        </Button>
        <Button onClick={onAccept} appearance="primary" title="Accept Selected">
          Accept
        </Button>
      </FlexContainer>
    </BannerContainer>
  );
};
